import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'path',
  standalone: true,
  pure: true
})
export class PathPipe implements PipeTransform {

transform(obj: any, path?: string | null): any {
    if (!obj || !path) return undefined;
    return path.split('.').reduce((acc, key) => acc?.[key], obj);
  }

}
